/**
 * Shared form-validation copy. Feature-specific wording lives in that feature's
 * namespace; only rules reused across forms belong here.
 */
const validation = {
  required: 'This field is required',
  maxLength: 'Must be at most {{max}} characters',
  minLength: 'Must be at least {{min}} characters',
  integer: 'Enter a whole number',
  range: 'Enter a value between {{min}} and {{max}}',
  min: 'Enter a value of {{min}} or more',
  nonNegative: 'Enter a value of 0 or more',
  invalidId: 'That identifier is not valid',
  invalidSelection: 'That selection is not valid',
  maxItems: 'Select at most {{max}} items',
};

export default validation;
